import React from 'react';

interface TabDescriptionProps {
    title: string;
    description: string;
    className?: string;
}

const TabDescription: React.FC<TabDescriptionProps> = ({
    title,
    description,
    className = 'tab-description',
}) => {
    return (
        <div className={className}>
            <div className={`${className}-title`}>{title}</div>
            <div className={`${className}-text`}>{description}</div>
        </div>
    );
};

export default TabDescription;
